import CitySEOHead from "@/components/feature/CitySEOHead";
import ParklandHeroSection from "./components/HeroSection";
import ParklandStickyNav from "./components/StickyNav";
import ParklandProcessingTimeSection from "./components/ProcessingTimeSection";
import ParklandServicesSection from "./components/ServicesSection";
import ParklandLocalAreaSection from "./components/LocalAreaSection";
import ParklandTravelTimingSection from "./components/TravelTimingSection";
import ParklandDestinationsSection from "./components/DestinationsSection";
import ParklandTestimonialsSection from "./components/TestimonialsSection";
import ParklandAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ParklandComparisonSection from "./components/ComparisonSection";
import ParklandMistakesSection from "./components/MistakesSection";
import ParklandHowItWorksSection from "./components/HowItWorksSection";
import ParklandFAQSection, { faqs } from "./components/FAQSection";
import ParklandHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import ParklandFinalCTA from "./components/FinalCTA";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function ParklandPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Parkland"
        state="Florida"
        stateAbbr="FL"
        route="/parkland"
        title="Emergency Passport Parkland, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Parkland, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Broward County travelers."
        geoPlacename="Parkland, Florida"
        geoPosition="26.3481;-80.2498"
        faqs={faqs}
        servicesSchema={servicesList}
      />
      <ParklandHeroSection />
      <ParklandStickyNav />
      <ParklandProcessingTimeSection />
      <ParklandServicesSection />
      <ParklandLocalAreaSection />
      <ParklandTravelTimingSection />
      <ParklandDestinationsSection />
      <ParklandTestimonialsSection />
      <ParklandAcceptanceFacilitiesSection />
      <ParklandComparisonSection />
      <ParklandMistakesSection />
      <ParklandHowItWorksSection />
      <ParklandFAQSection />
      <ParklandHelpfulResourcesSection />
      <ParklandFinalCTA />
    </div>
  );
}